// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file npc/v1/npc.proto (package npc.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file npc/v1/npc.proto.
 */
export const file_npc_v1_npc: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message npc.v1.DeliverQuestItemsRequest
 */
export type DeliverQuestItemsRequest = Message<"npc.v1.DeliverQuestItemsRequest"> & {
  /**
   * @generated from field: string npc_id = 1;
   */
  npcId: string;
};

/**
 * Describes the message npc.v1.DeliverQuestItemsRequest.
 * Use `create(DeliverQuestItemsRequestSchema)` to create a new message.
 */
export const DeliverQuestItemsRequestSchema: GenMessage<DeliverQuestItemsRequest> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 0);

/**
 * @generated from message npc.v1.DeliveredItem
 */
export type DeliveredItem = Message<"npc.v1.DeliveredItem"> & {
  /**
   * @generated from field: int32 item_id = 1;
   */
  itemId: number;

  /**
   * @generated from field: int32 quantity = 2;
   */
  quantity: number;
};

/**
 * Describes the message npc.v1.DeliveredItem.
 * Use `create(DeliveredItemSchema)` to create a new message.
 */
export const DeliveredItemSchema: GenMessage<DeliveredItem> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 1);

/**
 * @generated from message npc.v1.DeliverQuestItemsResponse
 */
export type DeliverQuestItemsResponse = Message<"npc.v1.DeliverQuestItemsResponse"> & {
  /**
   * @generated from field: repeated npc.v1.DeliveredItem delivered = 1;
   */
  delivered: DeliveredItem[];
};

/**
 * Describes the message npc.v1.DeliverQuestItemsResponse.
 * Use `create(DeliverQuestItemsResponseSchema)` to create a new message.
 */
export const DeliverQuestItemsResponseSchema: GenMessage<DeliverQuestItemsResponse> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 2);

/**
 * @generated from message npc.v1.NPCView
 */
export type NPCView = Message<"npc.v1.NPCView"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string sprite_id = 4;
   */
  spriteId: string;

  /**
   * @generated from field: optional string building_id = 5;
   */
  buildingId?: string | undefined;

  /**
   * @generated from field: optional double lat = 6;
   */
  lat?: number | undefined;

  /**
   * @generated from field: optional double lng = 7;
   */
  lng?: number | undefined;

  /**
   * @generated from field: string s2_cell = 8;
   */
  s2Cell: string;

  /**
   * raw JSONB dialog serialized as JSON
   *
   * @generated from field: string dialog_json = 9;
   */
  dialogJson: string;

  /**
   * @generated from field: string faction = 10;
   */
  faction: string;

  /**
   * @generated from field: bool enabled = 11;
   */
  enabled: boolean;

  /**
   * Coarse map-marker hint: this giver has enabled quests inside their
   * active window for the caller's level band. Per-player truth (prereqs,
   * cooldown, faction) stays on TalkNPC.
   *
   * @generated from field: bool has_quests_available = 12;
   */
  hasQuestsAvailable: boolean;

  /**
   * prefab_key names the character model, resolved client-side against a
   * catalog built from internal/npc/vocabulary/prefabs.json.
   *
   * IT SUPERSEDES sprite_id, WHICH IS DEAD AND STAYS ON THE WIRE FOR NOW.
   * sprite_id has been carried and written by admins since 021 and read by
   * nothing: QuestNpcView instantiates a prefab wired into the scene and never
   * looks at it, so every quest giver in the game is the same model. Its
   * contents are therefore WRONG rather than absent, which is exactly why this
   * is a new field instead of a reinterpretation of that one — reusing it
   * would render a cast as whatever somebody typed in 2024.
   *
   * Removing sprite_id is a separate change, once the client no longer reads
   * the field number.
   *
   * @generated from field: string prefab_key = 13;
   */
  prefabKey: string;

  /**
   * portrait_key names the dialogue-panel portrait.
   *
   * Shipped ahead of the art deliberately: the panel has no portrait element
   * today and Assets/_Project/Resources/QuestNpcs/ does not exist, so a client
   * that honours this finds nothing and falls back. Carrying it now means the
   * contract is one field rather than a second migration later.
   *
   * @generated from field: string portrait_key = 14;
   */
  portraitKey: string;
};

/**
 * Describes the message npc.v1.NPCView.
 * Use `create(NPCViewSchema)` to create a new message.
 */
export const NPCViewSchema: GenMessage<NPCView> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 3);

/**
 * @generated from message npc.v1.AvailableQuest
 */
export type AvailableQuest = Message<"npc.v1.AvailableQuest"> & {
  /**
   * @generated from field: string quest_id = 1;
   */
  questId: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: bool already_active = 5;
   */
  alreadyActive: boolean;

  /**
   * Reward preview so the player doesn't accept blind: aggregate of the
   * quest's reward rows (per-objective + completion).
   *
   * @generated from field: int32 reward_xp = 6;
   */
  rewardXp: number;

  /**
   * @generated from field: int64 reward_dirty_cash = 7;
   */
  rewardDirtyCash: bigint;

  /**
   * @generated from field: int64 reward_clean_influence = 8;
   */
  rewardCleanInfluence: bigint;

  /**
   * @generated from field: int32 reward_item_count = 9;
   */
  rewardItemCount: number;

  /**
   * @generated from field: bool repeatable = 10;
   */
  repeatable: boolean;

  /**
   * @generated from field: string category = 11;
   */
  category: string;

  /**
   * @generated from field: int32 min_level = 12;
   */
  minLevel: number;
};

/**
 * Describes the message npc.v1.AvailableQuest.
 * Use `create(AvailableQuestSchema)` to create a new message.
 */
export const AvailableQuestSchema: GenMessage<AvailableQuest> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 4);

/**
 * @generated from message npc.v1.PlayerQuestView
 */
export type PlayerQuestView = Message<"npc.v1.PlayerQuestView"> & {
  /**
   * @generated from field: string player_id = 1;
   */
  playerId: string;

  /**
   * @generated from field: string quest_id = 2;
   */
  questId: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: repeated string active_objective_ids = 4;
   */
  activeObjectiveIds: string[];

  /**
   * @generated from field: int64 started_at_unix_ms = 5;
   */
  startedAtUnixMs: bigint;

  /**
   * @generated from field: optional int64 completed_at_unix_ms = 6;
   */
  completedAtUnixMs?: bigint | undefined;

  /**
   * @generated from field: optional int64 cooldown_until_unix_ms = 7;
   */
  cooldownUntilUnixMs?: bigint | undefined;

  /**
   * Mirrors quest.v1.PlayerQuestView.quest_slug so StartQuestFromNPC's
   * return value isn't poorer than QuestService's.
   *
   * @generated from field: string quest_slug = 8;
   */
  questSlug: string;
};

/**
 * Describes the message npc.v1.PlayerQuestView.
 * Use `create(PlayerQuestViewSchema)` to create a new message.
 */
export const PlayerQuestViewSchema: GenMessage<PlayerQuestView> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 5);

/**
 * @generated from message npc.v1.ListNearbyNPCsRequest
 */
export type ListNearbyNPCsRequest = Message<"npc.v1.ListNearbyNPCsRequest"> & {
  /**
   * @generated from field: double lat = 1;
   */
  lat: number;

  /**
   * @generated from field: double lng = 2;
   */
  lng: number;

  /**
   * @generated from field: double radius_m = 3;
   */
  radiusM: number;

  /**
   * Optional faction filter; empty means "any".
   *
   * @generated from field: string faction = 4;
   */
  faction: string;
};

/**
 * Describes the message npc.v1.ListNearbyNPCsRequest.
 * Use `create(ListNearbyNPCsRequestSchema)` to create a new message.
 */
export const ListNearbyNPCsRequestSchema: GenMessage<ListNearbyNPCsRequest> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 6);

/**
 * @generated from message npc.v1.ListNearbyNPCsResponse
 */
export type ListNearbyNPCsResponse = Message<"npc.v1.ListNearbyNPCsResponse"> & {
  /**
   * @generated from field: repeated npc.v1.NPCView npcs = 1;
   */
  npcs: NPCView[];
};

/**
 * Describes the message npc.v1.ListNearbyNPCsResponse.
 * Use `create(ListNearbyNPCsResponseSchema)` to create a new message.
 */
export const ListNearbyNPCsResponseSchema: GenMessage<ListNearbyNPCsResponse> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 7);

/**
 * @generated from message npc.v1.GetNPCRequest
 */
export type GetNPCRequest = Message<"npc.v1.GetNPCRequest"> & {
  /**
   * @generated from field: string npc_id = 1;
   */
  npcId: string;
};

/**
 * Describes the message npc.v1.GetNPCRequest.
 * Use `create(GetNPCRequestSchema)` to create a new message.
 */
export const GetNPCRequestSchema: GenMessage<GetNPCRequest> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 8);

/**
 * @generated from message npc.v1.TalkNPCRequest
 */
export type TalkNPCRequest = Message<"npc.v1.TalkNPCRequest"> & {
  /**
   * @generated from field: string npc_id = 1;
   */
  npcId: string;
};

/**
 * Describes the message npc.v1.TalkNPCRequest.
 * Use `create(TalkNPCRequestSchema)` to create a new message.
 */
export const TalkNPCRequestSchema: GenMessage<TalkNPCRequest> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 9);

/**
 * @generated from message npc.v1.TalkNPCResponse
 */
export type TalkNPCResponse = Message<"npc.v1.TalkNPCResponse"> & {
  /**
   * @generated from field: npc.v1.NPCView npc = 1;
   */
  npc?: NPCView | undefined;

  /**
   * @generated from field: repeated npc.v1.AvailableQuest available_quests = 2;
   */
  availableQuests: AvailableQuest[];
};

/**
 * Describes the message npc.v1.TalkNPCResponse.
 * Use `create(TalkNPCResponseSchema)` to create a new message.
 */
export const TalkNPCResponseSchema: GenMessage<TalkNPCResponse> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 10);

/**
 * @generated from message npc.v1.StartQuestFromNPCRequest
 */
export type StartQuestFromNPCRequest = Message<"npc.v1.StartQuestFromNPCRequest"> & {
  /**
   * @generated from field: string npc_id = 1;
   */
  npcId: string;

  /**
   * @generated from field: string quest_id = 2;
   */
  questId: string;
};

/**
 * Describes the message npc.v1.StartQuestFromNPCRequest.
 * Use `create(StartQuestFromNPCRequestSchema)` to create a new message.
 */
export const StartQuestFromNPCRequestSchema: GenMessage<StartQuestFromNPCRequest> = /*@__PURE__*/
  messageDesc(file_npc_v1_npc, 11);

/**
 * NpcService is the player-facing gRPC for quest-giver NPCs. NPCs are
 * either standalone characters anchored to a lat/lng or bound to a
 * building (and inherit its location). Admin CRUD lives on
 * /admin/npcs/* HTTP routes (see internal/npc/bff_handler.go).
 *
 * Regeneration: merging a change to this file to main triggers the
 * proto-gen workflow, which commits the updated gen/go stubs; Unity C#
 * stubs are produced locally via UNITY_PROTO_OUT + scripts/gen-proto.sh.
 *
 * @generated from service npc.v1.NpcService
 */
export const NpcService: GenService<{
  /**
   * ListNearbyNPCs returns enabled NPCs within radius_m of (lat, lng).
   * Caller's faction restriction (passed via auth context) is honored
   * server-side.
   *
   * @generated from rpc npc.v1.NpcService.ListNearbyNPCs
   */
  listNearbyNPCs: {
    methodKind: "unary";
    input: typeof ListNearbyNPCsRequestSchema;
    output: typeof ListNearbyNPCsResponseSchema;
  },
  /**
   * GetNPC returns one NPC by id. Used by the client when re-opening
   * a dialog the player saved earlier.
   *
   * @generated from rpc npc.v1.NpcService.GetNPC
   */
  getNPC: {
    methodKind: "unary";
    input: typeof GetNPCRequestSchema;
    output: typeof NPCViewSchema;
  },
  /**
   * TalkNPC opens the dialog: returns the static dialog payload plus
   * any quests this NPC currently offers to the calling player. The
   * quest list filters by player level / faction / cooldown.
   *
   * @generated from rpc npc.v1.NpcService.TalkNPC
   */
  talkNPC: {
    methodKind: "unary";
    input: typeof TalkNPCRequestSchema;
    output: typeof TalkNPCResponseSchema;
  },
  /**
   * StartQuestFromNPC is the explicit "accept this quest" RPC. Returns
   * the freshly-created player_quests row. Equivalent to QuestService.
   * StartQuest with giver_kind="npc" and giver_ref=npc_id.
   *
   * @generated from rpc npc.v1.NpcService.StartQuestFromNPC
   */
  startQuestFromNPC: {
    methodKind: "unary";
    input: typeof StartQuestFromNPCRequestSchema;
    output: typeof PlayerQuestViewSchema;
  },
  /**
   * DeliverQuestItems performs the hand-over for every active
   * deliver_item objective targeting this NPC: consumes
   * min(held, remaining) of each target item from the player's street
   * inventory and advances the objectives (progress lands via the
   * normal quest WS frames). The player triggers it explicitly from the
   * dialog's Deliver button — talking alone never takes items. An empty
   * delivered list is the normal "nothing to hand over" outcome, not an
   * error.
   *
   * @generated from rpc npc.v1.NpcService.DeliverQuestItems
   */
  deliverQuestItems: {
    methodKind: "unary";
    input: typeof DeliverQuestItemsRequestSchema;
    output: typeof DeliverQuestItemsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_npc_v1_npc, 0);

